<template>
  <nav-bar title="督办" />
  <Content :bottom="76">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <div class="list">
      <van-checkbox-group v-model="checked" direction="horizontal">
        <van-checkbox v-for="item in list" :key="item.id" shape="square" :name="item.id">{{ item.name }}</van-checkbox>
      </van-checkbox-group>
    </div>
  </Content>
  <div
    class="btn-conatiner van-hairline--top"
  >
    <van-button
      block
      type="primary"
      :disabled="!checked.length"
      native-type="button"
      @click="popup.showPopup()"
    >
      {{checked.length ? `下一步（${checked.length}）` : '勾选督办人员'}}
    </van-button>
  </div>
  <Popup title="填写督办内容" ref="popup" minHeight="100%">
    <van-form @submit="handleSubmit">
        <van-field
          v-model="formData.title"
          name="title"
          label="督办标题"
          placeholder="督办标题"
          :rules="[{ required: true, message: '请填写督办内容' }]"
        />
        <van-field
          v-model="formData.maintext"
          name="maintext"
          rows="2"
          autosize
          label="督办内容"
          type="textarea"
          maxlength="100"
          placeholder="督办内容"
          show-word-limit
          :rules="[{ required: true, message: '请填督办内容' }]"
        />
        <div class="btn-submit">
          <van-button  block type="primary" :disabled="loading" :loading="loading" native-type="submit">
            提交
          </van-button>
        </div>
    </van-form>
  </Popup>
</template>

<script>
import { computed, reactive, ref, watch } from 'vue'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useSubmit } from '@/hooks/useSubmit'
import { getCompanyLeaderById, batchAdd } from '@/api/user'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  name: 'Supervise2',
  props: ['companyId'],
  setup(props) {
    const store = useStore()
    const useId = computed(() => store.state.userInfo.id)
    const checked = ref([])
    const popup = ref(null)
    const list = ref([])
    watch(() => checked.value, () => {
      formData.receiveUserList = checked.value
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getCompanyLeaderById,
      data => {
        list.value = data
      },
      {
        companyId: props.companyId
      }
    )
    getDataLoading()

    const formData = reactive(
      {
        title: '',
        maintext: '',
        msgTypeInfo: props.type,
        msgFrom: useId.value,
        receiveUserList: []
      }
    )
    const router = useRouter()
    const { loading, onSubmit } = useSubmit(batchAdd, formData, data => {
      popup.value.hidePopup()
      formData.title = ''
      formData.maintext = ''
      checked.value = []
      router.back()
    })
    const handleSubmit = (val) => {
      onSubmit()
    }
    return { list, checked, getDataLoading, showLoading, isLoading, popup, formData, onSubmit, loading, handleSubmit }
  }
}
</script>

<style lang="scss" scoped>
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background-color: #fff;
}
.btn-submit {
  margin: 16px;
}
.list {
  padding: 16px;
  font-size: 14px;
  .van-checkbox {
    margin-bottom: 16px;
    width: 33.3%;
    margin-right: 0;
    font-weight: 600;
  }
}
</style>
